import palette from '../palette';

export default {
  colorDefault: {
    backgroundColor: palette.white,
  },
};
